import styled from 'styled-components';

const Wrapper = styled.div`
  ${({ theme }) => `
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6, BB7 */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flexbox;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  form {
    width: 100%;
    // padding: 3%;
  }
  .nowrap {
      white-space: nowrap;
  }
  #companyInfoSubmit {
    min-width: 210px;
  }
  .helperText{
    margin-top: -15px;
    font-size: 0.8rem;
  }
  .buttonSection {
    display: flex;
    justify-content: flex-end;
  }
  .companyInfoSubmit {
    margin-right: 1%;
  }
  .creditCardWrapper {
    padding-bottom: 1%;
    gap:1rem;
    #creditCardUpdate {
        margin-top: 0;
    }
  }
  .subscriptionCompany {
    flex: 0 0 25%;
  }
  .cycleruleSection{
    display: flex;
    flex-direction: column;
    width: 48%;
  }
  `}
`;
const leftSection = styled.div`
${({ theme }) => `
  flex: 0 0 100%;
  display: flex;
  justify-content: space-between;
  .values {
    color: ${theme.colors.PRIMARY_CONTRAST};
  }
  .checkboxesCompany{
    display: flex;
    .agreeTerms{
      flex: 0 0 60%;
    }
  }
  .valueWrapper{
    min-height: 39px;
    .MuiFormLabel-root{
      padding-right: 18px;
      line-height: 1.3;
    }
  }
`}
`;
const rightSection = styled.div`
${({ theme }) => `
  flex: 0 0 100%;
  display: flex;
  justify-content: space-between;
  
 
`}
`;
const TextWrapper = styled.div`
${({ theme }) => `
  flex: 0 0 75%;
`}
`;

const FieldsWrapper = styled.div`
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6, BB7 */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flexbox;
  display: flex;
`;
const wrapperSection = styled.div`
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6, BB7 */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flexbox;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  .companyForm{
    flex: 0 0 48%;
  }
`;
const InsuranceCompanyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Styled = {
  Wrapper,
  TextWrapper,
  FieldsWrapper,
  leftSection,
  rightSection,
  wrapperSection,
  InsuranceCompanyWrapper
};

export default Styled;
